export default interface RoleDomain {
    code: string,
    name: string,
    status: string
}

export const DefaultRoleModel: RoleDomain = {
    code: "",
    name: "",
    status: "ENABLE"
}
